import React from 'react'
import { Link } from 'react-router-dom'

const Prevencion = () => {
   return (
      <>
         <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
               <h5><b>PREVENCIÓN</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Relevamiento de Agentes de Riesgo (RAR)</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/RAR.xlsx`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse" >Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Relevamiento General de Riesgos Laborales – RGRL Dec. 351 – Comercio e Industria</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a  href={`${process.env.REACT_APP_API_URL}/web/download/D351.pdf`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Relevamiento General de Riesgos Laborales – RGRL Dec. 911 – Construcción</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/D911.pdf`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Relevamiento General de Riesgos Laborales – RGRL Dec. 617 – Agro</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/D617.pdf`} rel="noopener noreferrer" className="btn  btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Aviso de Obra</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/AvisoDeObra.pdf`} rel="noopener noreferrer" className="btn  btn-large waves-effect waves-light bg-latitud pulse" type="submit" name="action">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Listado de Agentes de Riesgos</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/AgentesDeRiesgo.pdf`} rel="noopener noreferrer" className="btn  btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Planilla de Registro de Entrega de EPP Res. N° 299/11</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download//FormularioEPP.xls`} rel="noopener noreferrer" className="btn  btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Manual de buenas prácticas en el Cultivo de Tabaco</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/ManualBuenasPracticasTabaco2019ModJulio2020.pdf`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Código CIUO (Clasificación Internacional Uniforme de Ocupaciones)</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/CodigosCIUO.pdf`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Código CIIUR4 (Clasificación Internacional Industrial Uniforme)</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/ciiur4.pdf`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Instructivo Carga de RAR - WEB Y Físico</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <a href={`${process.env.REACT_APP_API_URL}/web/download/InstructivoCargaDeRARWebFisico.pdf`} rel="noopener noreferrer" className="btn btn-large waves-effect waves-light bg-latitud pulse">Descargar
                  <i className="material-icons right">cloud_download</i>
               </a>
            </div>
            <div id="seccionSiniestros"/>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
      </>
   )
}

export default Prevencion